import { render } from "./HFO_LO_001_FOODCON.vue?vue&type=template&id=133e5cbc&scoped=true"
import script from "./HFO_LO_001_FOODCON.vue?vue&type=script&lang=js"
export * from "./HFO_LO_001_FOODCON.vue?vue&type=script&lang=js"

import "./HFO_LO_001_FOODCON.vue?vue&type=style&index=0&id=133e5cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133e5cbc"]])

export default __exports__